/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon24Regular = forwardRef('AwardMedalIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.573 2.758a.75.75 0 0 1 1.045.185L12 6.35l2.382-3.407a.75.75 0 0 1 1.23.86l-2.63 3.76a7.458 7.458 0 0 1 3.283 1.267l4.117-5.887a.75.75 0 0 1 1.23.86l-4.2 6.004a7.5 7.5 0 1 1-10.823 0l-4.2-6.004a.75.75 0 1 1 1.229-.86L7.735 8.83a7.457 7.457 0 0 1 3.283-1.266l-2.63-3.761a.75.75 0 0 1 .185-1.045ZM6 15a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
